import React, { useContext } from "react";
import { Box, InputAdornment, MenuItem, Select } from "@mui/material";
import PublicIcon from "@mui/icons-material/Public";
import { useLocation, useNavigate } from "react-router-dom";
import {
  buildLocalizedPathname,
  KivuI18nContext,
  LANGUAGE_MAP,
  LOCALE,
  SUPPORTED_LOCALE
} from "@kivunova/kivufrontendcommon";
import { markUserLocaleSwitch } from "../../Utils/localeNavigation";

const LanguageSelector: React.FC = () => {
  const { language, setLanguage, defaultLang } = useContext(KivuI18nContext);
  const location = useLocation();
  const navigate = useNavigate();

  if (!language || !setLanguage || !defaultLang) return null;

  const handleChange = (nextLocale: LOCALE) => {
    const nextPath = buildLocalizedPathname(
      location.pathname,
      nextLocale,
      defaultLang
    );

    markUserLocaleSwitch(nextLocale);
    setLanguage(nextLocale);

    if (nextPath !== location.pathname) {
      navigate(
        {
          pathname: nextPath,
          search: location.search,
          hash: location.hash
        },
        { replace: true }
      );
    }
    // Same-path switches (e.g. default locale) keep pending until LanguageLayout
    // sees context and pathname aligned.
  };

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        minWidth: "120px",
        zIndex: 10
      }}
    >
      <Select
        value={language}
        onChange={(e) => handleChange(e.target.value as LOCALE)}
        variant="outlined"
        size="small"
        sx={{
          fontSize: "small",
          bgcolor: "background.paper",
          "& .MuiSelect-select": {
            display: "flex",
            alignItems: "center"
          },
          "& .MuiOutlinedInput-notchedOutline": {
            border: "none"
          }
        }}
        startAdornment={
          <InputAdornment position="start">
            <PublicIcon fontSize="small" sx={{ color: "#a78bfa" }} />
          </InputAdornment>
        }
      >
        {Object.entries(LANGUAGE_MAP)
          .filter(([code]) => SUPPORTED_LOCALE.includes(code as LOCALE))
          .map(([code, label]) => (
            <MenuItem key={code} value={code} style={{ fontSize: "small" }}>
              {label}
            </MenuItem>
          ))}
      </Select>
    </Box>
  );
};

export default LanguageSelector;
